import React from "react";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager, WebTarget } from "styled-components";
import { ThemeComponent } from "./components/theme-component";
import Autosuggest from "./views/autosuggest";

const shouldForwardProp = (propName: string, target: WebTarget | undefined) => {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
};

const App: React.FC<{
  brand?: "default" | "littlewoods" | "very" | "veryireland";
}> = ({ brand = "very" }) => {
  return (
    <StyleSheetManager
      enableVendorPrefixes
      shouldForwardProp={shouldForwardProp}
    >
      <ThemeComponent brand={brand} />
      <Autosuggest brand={brand} />
    </StyleSheetManager>
  );
};

export default App;
